import { MANUAL_DEPOSIT_PAYMENT_METHODS } from '../components/MarkDepositPaidModal';

export function formatManualPaymentMethodLabel(code: string | null | undefined): string {
  const trimmed = (code || '').trim();
  if (!trimmed) return '—';
  const found = MANUAL_DEPOSIT_PAYMENT_METHODS.find((option) => option.value === trimmed);
  if (found) return found.label;
  return trimmed.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}
